import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApiService } from '../services/api.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class BlogDetailResolveService implements Resolve<any> {

  memberId: any
  
  constructor(
    private apiService:ApiService,
    private translateService: TranslateService,
  ) { }
 
  resolve(route: ActivatedRouteSnapshot) {
    if(route.paramMap.get('code')) {
      return this.apiService.get(`${environment.API}/api/v1/public/blog/${route.paramMap.get('code')}?language=${route.queryParams['lang'] || this.translateService.currentLang}`)
    }
    else {
      return {}
    }
  }
}